import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { PointConversionComponent } from "../new-v2-component/point-conversion/point-conversion.component";
import { AlertService } from "src/app/providers/alert.service";

@Component({
  selector: "sm-loyalty-configurer",
  templateUrl: "./loyalty-configurer.component.html",
  styleUrls: ["./loyalty-configurer.component.scss"],
})
export class LoyaltyConfigurerComponent implements OnInit, OnDestroy {
  home_status: any = sessionStorage.getItem("home_service_status");
  shop_status: any = sessionStorage.getItem("shop_service_status");
  virtual_status: any = sessionStorage.getItem("virtual_service_status");
  apisub: Subscription;
  entityLoyaltyConfiguration: any = {};
  panelState: any = [true, false, false, false, false, false];
  selectedValue: number = 3;
  loader: boolean = false;
  isPointToReferee: boolean = false;
  // Main Toggles
  toShowCheckForBooking: number = 0;
  toShowCheckForPayment: number = 0;
  toShowCheckForReferral: number = 0;
  toShowCheckForMembership: number = 0;

  // --- Booking Section Variables ---
  isShopBookingEnabled: boolean = false;
  bookingShopPoints: any;
  bookingShopValidity: any;
  isHomeBookingEnabled: boolean = false;
  bookingHomePoints: any;
  bookingHomeValidity: any;
  isVirtualBookingEnabled: boolean = false;
  bookingVirtualPoints: any;
  bookingVirtualValidity: any;

  // --- Membership Section Variables ---
  isInPremiseMembershipEnabled: boolean = false;
  membershipInPremisePoints: any;
  membershipInPremiseValidity: any;
  isHomeMembershipEnabled: boolean = false;
  membershipHomePoints: any;
  membershipHomeValidity: any;
  isVirtualMembershipEnabled: boolean = false;
  membershipVirtualPoints: any;
  membershipVirtualValidity: any;

  // --- Payment Section Variables ---
  isAppointmentPaymentEnabled: boolean = false;
  appointmentPaymentType: string = "each_payment";
  aptFixedPoints: any;
  aptAmountLimit: any;
  aptRewardPoints: any;
  paymentAppointmentValidity: any;
  paymentMembrshipValidity: any;
  paymentOtherValidity: any;

  isMembershipPaymentEnabled: boolean = false;
  membershipPaymentType: string = "each_payment";
  memFixedPoints: any;
  memAmountLimit: any;
  memRewardPoints: any;

  isOtherPaymentEnabled: boolean = false;
  otherPaymentType: string = "each_payment";
  othFixedPoints: any;
  othAmountLimit: any;
  othRewardPoints: any;

  // --- Referral Section Variables ---
  isReferFriendEnabled: boolean = false;
  referFriendPoints: any;
  referFriendReferrerPoints: any;
  referFriendReferredPointsValidity: any;
  isBookingByRefereeEnabled: boolean = false;
  refereeBookingPoints: any;
  isPaymentByRefereeEnabled: boolean = false;
  referralPaymentType: string = "each_payment";
  referralPaymentFixedPoints: any;
  referralPaymentAmountLimit: any;
  referralPaymentRewardPoints: any;
  referralValidity: any;
  referralBookingValidity: any;
  referralPaymentValidity: any;

  childupdatemsg: any = null;

  constructor(
    private navservice: NavigationService,
    private ls: LoaderServiceService,
    private route: ActivatedRoute,
    private apiservice: ApiService,
    private dialog: MatDialog,
    private alertservice: AlertService,
  ) {
    this.navservice.hideSidebarAndNav = false;
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENTITY_LOYALTY_CONFIGURATION
      ) {
        if (resdata.result) {
          this.entityLoyaltyConfiguration = resdata.result;

          this.entityLoyaltyConfiguration.entity_loyalty_configuration =
            typeof this.entityLoyaltyConfiguration
              .entity_loyalty_configuration == "string"
              ? JSON.parse(
                  this.entityLoyaltyConfiguration.entity_loyalty_configuration,
                )
              : this.entityLoyaltyConfiguration.entity_loyalty_configuration;

          this.entityLoyaltyConfiguration.booking_loyalty_configuration =
            typeof this.entityLoyaltyConfiguration
              .booking_loyalty_configuration == "string"
              ? JSON.parse(
                  this.entityLoyaltyConfiguration.booking_loyalty_configuration,
                )
              : this.entityLoyaltyConfiguration.booking_loyalty_configuration;

          this.entityLoyaltyConfiguration.membership_loyalty_configuration =
            typeof this.entityLoyaltyConfiguration
              .membership_loyalty_configuration == "string"
              ? JSON.parse(
                  this.entityLoyaltyConfiguration
                    .membership_loyalty_configuration,
                )
              : this.entityLoyaltyConfiguration
                  .membership_loyalty_configuration;

          this.entityLoyaltyConfiguration.entity_payment_loyalty_configuration =
            typeof this.entityLoyaltyConfiguration
              .entity_payment_loyalty_configuration == "string"
              ? JSON.parse(
                  this.entityLoyaltyConfiguration
                    .entity_payment_loyalty_configuration,
                )
              : this.entityLoyaltyConfiguration
                  .entity_payment_loyalty_configuration;

          this.entityLoyaltyConfiguration.referral_loyalty_configuration =
            typeof this.entityLoyaltyConfiguration
              .referral_loyalty_configuration == "string"
              ? JSON.parse(
                  this.entityLoyaltyConfiguration
                    .referral_loyalty_configuration,
                )
              : this.entityLoyaltyConfiguration.referral_loyalty_configuration;

          if (this.entityLoyaltyConfiguration.entity_loyalty_configuration) {
            this.setTogglesFromApi(
              this.entityLoyaltyConfiguration.entity_loyalty_configuration,
            );
          }

          this.setSubConfigurations();
        }
        this.ls.showLoader = false;
        this.loader = false;

        if (this.mainupdatemsg && this.mainupdatemsg != "") {
          this.alertservice.onOpenSnackbar(this.mainupdatemsg, 3000);
          this.mainupdatemsg = null;
        }
        if (this.childupdatemsg && this.childupdatemsg != "") {
          this.alertservice.onOpenSnackbar(this.childupdatemsg, 3000);
          this.childupdatemsg = null;
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_SET_ENTITY_LOYALTY_CONFIGURATION
      ) {
        if (resdata.result) {
          this.apiservice.getEntityLoyaltyConfiguration(this.entityHash);
        }
      }

      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_SET_ENTITY_BOOKING_LOYALTY_CONFIGURATION
      ) {
        if (resdata.result) {
          this.apiservice.getEntityLoyaltyConfiguration(this.entityHash);
          this.childupdatemsg =
            "Booking loyalty reward setup changed successfully.";
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_SET_ENTITY_PAYMENT_LOYALTY_CONFIGURATION
      ) {
        if (resdata.result) {
          this.apiservice.getEntityLoyaltyConfiguration(this.entityHash);
          this.childupdatemsg =
            "Payment loyalty reward setup changed successfully.";
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_SET_ENTITY_REFERRAL_LOYALTY_CONFIGURATION
      ) {
        if (resdata.result) {
          this.apiservice.getEntityLoyaltyConfiguration(this.entityHash);
          this.childupdatemsg =
            "Referral loyalty reward setup changed successfully.";
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_SET_ENTITY_MEMBERSHIP_LOYALTY_CONFIGURATION
      ) {
        if (resdata.result) {
          this.apiservice.getEntityLoyaltyConfiguration(this.entityHash);
          this.childupdatemsg =
            "Membership loyalty reward setup changed successfully.";
        }
      }
    });
  }
  entityHash: any;
  currencyInfo: any;
  ngOnInit(): void {
    this.loader = true;
    this.ls.showLoader = true;
    if (
      sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT)
    ) {
      this.currencyInfo =
        typeof sessionStorage.getItem(
          SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,
        ) == "string"
          ? JSON.parse(
              sessionStorage.getItem(
                SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,
              )!,
            )
          : sessionStorage.getItem(
              SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,
            );
    }
    this.route.queryParams.subscribe((data) => {
      if (data) {
        this.entityHash = data.entityHash;
      }
    });
    this.apiservice.getEntityLoyaltyConfiguration(this.entityHash);
  }

  selectchip(value: number) {
    this.selectedValue = value;
  }

  // Logic to handle the main status from your API array
  setTogglesFromApi(data: any[]) {
    this.toShowCheckForBooking = 0;
    this.toShowCheckForPayment = 0;
    this.toShowCheckForReferral = 0;
    this.toShowCheckForMembership = 0;

    if (data && data.length > 0) {
      data.forEach((item) => {
        if (item.configuration_type === 1)
          this.toShowCheckForBooking = item.configuration_status;
        if (item.configuration_type === 2)
          this.toShowCheckForPayment = item.configuration_status;
        if (item.configuration_type === 3)
          this.toShowCheckForReferral = item.configuration_status;
        if (item.configuration_type === 4)
          this.toShowCheckForMembership = item.configuration_status;
      });
    }
  }

  // Logic to map all sub-details (toggles, radios, inputs)
  setSubConfigurations() {
    const config = this.entityLoyaltyConfiguration;

    // 1. Booking Sub-Items
    if (config.booking_loyalty_configuration) {
      config.booking_loyalty_configuration.forEach((item: any) => {
        if (item.configuration_type === 1) {
          this.isShopBookingEnabled = item.configuration_status === 1;
          this.bookingShopPoints = item.points_per_booking;
          this.bookingShopValidity = item.validity_in_days;
        } else if (item.configuration_type === 2) {
          this.isHomeBookingEnabled = item.configuration_status === 1;
          this.bookingHomePoints = item.points_per_booking;
          this.bookingHomeValidity = item.validity_in_days;
        } else if (item.configuration_type === 3) {
          this.isVirtualBookingEnabled = item.configuration_status === 1;
          this.bookingVirtualPoints = item.points_per_booking;
          this.bookingVirtualValidity = item.validity_in_days;
        }
      });
    }

    // 1. Membership Sub-Items
    if (config.membership_loyalty_configuration) {
      config.membership_loyalty_configuration.forEach((item: any) => {
        if (item.configuration_type === 1) {
          this.isInPremiseMembershipEnabled = item.configuration_status === 1;
          this.membershipInPremisePoints = item.points_on_membership;
          this.membershipInPremiseValidity = item.validity_in_days;
        } else if (item.configuration_type === 2) {
          this.isHomeMembershipEnabled = item.configuration_status === 1;
          this.membershipHomePoints = item.points_on_membership;
          this.membershipHomeValidity = item.validity_in_days;
        } else if (item.configuration_type === 3) {
          this.isVirtualMembershipEnabled = item.configuration_status === 1;
          this.membershipVirtualPoints = item.points_on_membership;
          this.membershipVirtualValidity = item.validity_in_days;
        }
      });
    }

    // 2. Payment Sub-Items
    if (config.entity_payment_loyalty_configuration) {
      config.entity_payment_loyalty_configuration.forEach((item: any) => {
        this.mapPaymentOrReferralItem(item);
      });
    }

    // 3. Referral Sub-Items
    if (config.referral_loyalty_configuration) {
      config.referral_loyalty_configuration.forEach((item: any) => {
        if (item.configuration_type === 1) {
          this.isReferFriendEnabled = item.configuration_status === 1;
          this.referFriendPoints = item.point_value;
          this.referralValidity = item.validity_in_days;
          this.isPointToReferee =
            item.is_refree_point_applicable == 1 ? true : false;
          this.referFriendReferrerPoints = item.referee_point_value;
          this.referFriendReferredPointsValidity =
            item.referee_point_validity_in_days;
        } else if (item.configuration_type === 2) {
          this.isBookingByRefereeEnabled = item.configuration_status === 1;
          this.refereeBookingPoints = item.point_value;
          this.referralBookingValidity = item.validity_in_days;
        } else if (item.configuration_type === 3) {
          this.isPaymentByRefereeEnabled = item.configuration_status === 1;
          this.referralPaymentType =
            item.point_type === 1 ? "each_payment" : "payment_amount";
          this.referralPaymentFixedPoints = item.point_value;
          this.referralPaymentAmountLimit = item.payment_per_point;
          this.referralPaymentRewardPoints = item.point_value;
          this.referralPaymentValidity = item.validity_in_days;
        }
      });
    }
  }

  mapPaymentOrReferralItem(item: any) {
    const isEnabled = item.configuration_status === 1;
    const type = item.point_type === 1 ? "each_payment" : "payment_amount";

    if (item.configuration_type === 1) {
      // Appointment
      this.isAppointmentPaymentEnabled = isEnabled;
      this.appointmentPaymentType = type;
      this.aptFixedPoints = item.point_value;
      this.aptAmountLimit = item.payment_per_point;
      this.aptRewardPoints = item.point_value;
      this.paymentAppointmentValidity = item.validity_in_days;
    } else if (item.configuration_type === 2) {
      // Membership
      this.isMembershipPaymentEnabled = isEnabled;
      this.membershipPaymentType = type;
      this.memFixedPoints = item.point_value;
      this.memAmountLimit = item.payment_per_point;
      this.memRewardPoints = item.point_value;
      this.paymentMembrshipValidity = item.validity_in_days;
    } else if (item.configuration_type === 3) {
      // Other
      this.isOtherPaymentEnabled = isEnabled;
      this.otherPaymentType = type;
      this.othFixedPoints = item.point_value;
      this.othAmountLimit = item.payment_per_point;
      this.othRewardPoints = item.point_value;
      this.paymentOtherValidity = item.validity_in_days;
    }
  }

  onToggleChangeForBooking(event: any) {
    this.toShowCheckForBooking = event.checked ? 1 : 0;
    const newStatus = event.checked ? 1 : 0;
    this.updateMainStatus(1, newStatus);
  }
  onToggleChangeForPayment(event: any) {
    this.toShowCheckForPayment = event.checked ? 1 : 0;
    const newStatus = event.checked ? 1 : 0;
    this.updateMainStatus(2, newStatus);
  }
  onToggleChangeForReferral(event: any) {
    this.toShowCheckForReferral = event.checked ? 1 : 0;
    const newStatus = event.checked ? 1 : 0;
    this.updateMainStatus(3, newStatus);
  }
  onToggleChangeForMembership(event: any) {
    this.toShowCheckForMembership = event.checked ? 1 : 0;
    const newStatus = event.checked ? 1 : 0;
    this.updateMainStatus(4, newStatus);
  }

  isMembershipSaveDisabled(): boolean {
    if (this.toShowCheckForMembership !== 1) return true;

    const validations = [
      {
        enabled: this.isInPremiseMembershipEnabled,
        points: this.membershipInPremisePoints,
        validity: this.membershipInPremiseValidity,
      },
      {
        enabled: this.isHomeMembershipEnabled,
        points: this.membershipHomePoints,
        validity: this.membershipHomeValidity,
      },
      {
        enabled: this.isVirtualMembershipEnabled,
        points: this.membershipVirtualPoints,
        validity: this.membershipVirtualValidity,
      },
    ];

    // At least one booking type must be enabled
    // if (!validations.some(v => v.enabled)) return true;

    // If enabled → both points & validity must be valid numbers > 0
    for (const item of validations) {
      if (item.enabled) {
        if (
          !item.points ||
          isNaN(item.points) ||
          Number(item.points) <= 0 ||
          !item.validity ||
          isNaN(item.validity) ||
          Number(item.validity) <= 0
        ) {
          return true;
        }
      }
    }

    return false;
  }

  isBookingSaveDisabled(): boolean {
    if (this.toShowCheckForBooking !== 1) return true;

    const validations = [
      {
        enabled: this.isShopBookingEnabled,
        points: this.bookingShopPoints,
        validity: this.bookingShopValidity,
      },
      {
        enabled: this.isHomeBookingEnabled,
        points: this.bookingHomePoints,
        validity: this.bookingHomeValidity,
      },
      {
        enabled: this.isVirtualBookingEnabled,
        points: this.bookingVirtualPoints,
        validity: this.bookingVirtualValidity,
      },
    ];

    // At least one booking type must be enabled
    // if (!validations.some(v => v.enabled)) return true;

    // If enabled → both points & validity must be valid numbers > 0
    for (const item of validations) {
      if (item.enabled) {
        if (
          !item.points ||
          isNaN(item.points) ||
          Number(item.points) <= 0 ||
          !item.validity ||
          isNaN(item.validity) ||
          Number(item.validity) <= 0
        ) {
          return true;
        }
      }
    }

    return false;
  }

  isPaymentSaveDisabled(): boolean {
    if (this.toShowCheckForPayment !== 1) return true;

    const sections = [
      {
        enabled: this.isAppointmentPaymentEnabled,
        type: this.appointmentPaymentType,
        fixed: this.aptFixedPoints,
        amount: this.aptAmountLimit,
        reward: this.aptRewardPoints,
        validity: this.paymentAppointmentValidity,
      },
      {
        enabled: this.isMembershipPaymentEnabled,
        type: this.membershipPaymentType,
        fixed: this.memFixedPoints,
        amount: this.memAmountLimit,
        reward: this.memRewardPoints,
        validity: this.paymentMembrshipValidity,
      },
      {
        enabled: this.isOtherPaymentEnabled,
        type: this.otherPaymentType,
        fixed: this.othFixedPoints,
        amount: this.othAmountLimit,
        reward: this.othRewardPoints,
        validity: this.paymentOtherValidity,
      },
    ];

    // if (!sections.some(s => s.enabled)) return true;

    for (const s of sections) {
      if (!s.enabled) continue;

      if (!s.validity || Number(s.validity) <= 0) return true;

      if (s.type === "each_payment") {
        if (!s.fixed || Number(s.fixed) <= 0) return true;
      } else {
        if (
          !s.amount ||
          Number(s.amount) <= 0 ||
          !s.reward ||
          Number(s.reward) <= 0
        ) {
          return true;
        }
      }
    }

    return false;
  }

  isReferralSaveDisabled(): boolean {
    if (this.toShowCheckForReferral !== 1) return true;

    const sections = [
      {
        enabled: this.isReferFriendEnabled,
        fixed: this.referFriendPoints,
        validity: this.referralValidity,
      },
      {
        enabled: this.isBookingByRefereeEnabled,
        fixed: this.refereeBookingPoints,
        validity: this.referralBookingValidity,
      },
      {
        enabled: this.isPaymentByRefereeEnabled,
        type: this.referralPaymentType,
        fixed: this.referralPaymentFixedPoints,
        amount: this.referralPaymentAmountLimit,
        reward: this.referralPaymentRewardPoints,
        validity: this.referralPaymentValidity,
      },
    ];

    // if (!sections.some(s => s.enabled)) return true;

    for (const s of sections) {
      if (!s.enabled) continue;

      if (!s.validity || Number(s.validity) <= 0) return true;

      if (s.type) {
        if (s.type === "each_payment") {
          if (!s.fixed || Number(s.fixed) <= 0) return true;
        } else {
          if (
            !s.amount ||
            Number(s.amount) <= 0 ||
            !s.reward ||
            Number(s.reward) <= 0
          )
            return true;
        }
      } else {
        if (!s.fixed || Number(s.fixed) <= 0) return true;
      }
    }

    return false;
  }

  // ------------ API CALLINGS AND HELPERS -------------- //
  mainupdatemsg: any = null;

  updateMainStatus(type: number, status: number) {
    let msgTitle = [
      "Booking Loyalty Rewards",
      "Payment Loyalty Rewards",
      "Referral Loyalty Rewards",
      "Membership Loyalty Rewards",
    ];
    const payload = {
      entity_hash: this.entityHash,
      configuration_type: type,
      configuration_status: status,
      created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      name: "Loyalty reward status",
      description:
        "Customers earn points automatically based on the rules you enable. Whether it is booking a service, completing a payment, or referring a friend, points are calculated and added instantly upon action.",
    };
    console.log(payload);
    this.mainupdatemsg =
      msgTitle[type - 1] +
      (status == 1 ? " enabled successfully." : " disabled successfully.");
    this.ls.showLoader = true;
    this.apiservice.setEntityLoyaltyConfiguration(payload);
  }

  buildBookingLoyaltyPayload() {
    const configs: any[] = [];

    // Shop Booking → configuration_type = 1
    configs.push({
      configuration_type: 1,
      configuration_status: this.isShopBookingEnabled ? 1 : 0,
      points_per_booking: this.bookingShopPoints || 0,
      validity_in_days: this.bookingShopValidity || 0,
    });

    // Home Booking → configuration_type = 2
    configs.push({
      configuration_type: 2,
      configuration_status: this.isHomeBookingEnabled ? 1 : 0,
      points_per_booking: this.bookingHomePoints || 0,
      validity_in_days: this.bookingHomeValidity || 0,
    });

    // Virtual Booking → configuration_type = 3
    configs.push({
      configuration_type: 3,
      configuration_status: this.isVirtualBookingEnabled ? 1 : 0,
      points_per_booking: this.bookingVirtualPoints || 0,
      validity_in_days: this.bookingVirtualValidity || 0,
    });

    return configs;
  }
  buildMembershipLoyaltyPayload() {
    const configs: any[] = [];

    // Shop Booking → configuration_type = 1
    configs.push({
      configuration_type: 1,
      configuration_status: this.isInPremiseMembershipEnabled ? 1 : 0,
      points_on_membership: this.membershipInPremisePoints || 0,
      validity_in_days: this.membershipInPremiseValidity || 0,
    });

    // Home Booking → configuration_type = 2
    configs.push({
      configuration_type: 2,
      configuration_status: this.isHomeMembershipEnabled ? 1 : 0,
      points_on_membership: this.membershipHomePoints || 0,
      validity_in_days: this.membershipHomeValidity || 0,
    });

    // Virtual Booking → configuration_type = 3
    configs.push({
      configuration_type: 3,
      configuration_status: this.isVirtualMembershipEnabled ? 1 : 0,
      points_on_membership: this.membershipVirtualPoints || 0,
      validity_in_days: this.membershipVirtualValidity || 0,
    });

    return configs;
  }
  saveMembershipLoyaltyConfiguration() {
    const result =
      this.entityLoyaltyConfiguration.entity_loyalty_configuration.find(
        (item: any) => item.configuration_type === this.selectedValue,
      );
    const payload = {
      entity_hash: this.entityHash,
      created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      entity_loyalty_configuration_hash: result ? result.hash_id : 0,
      configurations: this.buildMembershipLoyaltyPayload(),
    };

    console.log("Membership Loyalty Payload", payload);

    this.ls.showLoader = true;
    this.apiservice.setEntityMembershipLoyaltyConfiguration(payload);
  }
  saveBookingLoyaltyConfiguration() {
    const result =
      this.entityLoyaltyConfiguration.entity_loyalty_configuration.find(
        (item: any) => item.configuration_type === this.selectedValue,
      );
    const payload = {
      entity_hash: this.entityHash,
      created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      entity_loyalty_configuration_hash: result ? result.hash_id : 0,
      configurations: this.buildBookingLoyaltyPayload(),
    };

    console.log("Booking Loyalty Payload", payload);

    this.ls.showLoader = true;
    this.apiservice.setEntityBookingLoyaltyConfiguration(payload);
  }

  buildPaymentLoyaltyPayload() {
    const configs: any[] = [];

    // Appointment Payment → configuration_type = 1
    configs.push({
      configuration_type: 1,
      configuration_status: this.isAppointmentPaymentEnabled ? 1 : 0,
      point_type: this.appointmentPaymentType === "each_payment" ? 1 : 2,
      point_value:
        this.appointmentPaymentType === "each_payment"
          ? this.aptFixedPoints || 0
          : this.aptRewardPoints || 0,
      payment_per_point:
        this.appointmentPaymentType === "payment_amount"
          ? this.aptAmountLimit || 0
          : 0,
      validity_in_days: this.paymentAppointmentValidity || 0,
    });

    // Membership Payment → configuration_type = 2
    configs.push({
      configuration_type: 2,
      configuration_status: this.isMembershipPaymentEnabled ? 1 : 0,
      point_type: this.membershipPaymentType === "each_payment" ? 1 : 2,
      point_value:
        this.membershipPaymentType === "each_payment"
          ? this.memFixedPoints || 0
          : this.memRewardPoints || 0,
      payment_per_point:
        this.membershipPaymentType === "payment_amount"
          ? this.memAmountLimit || 0
          : 0,
      validity_in_days: this.paymentMembrshipValidity || 0,
    });

    // Other Payment → configuration_type = 3
    configs.push({
      configuration_type: 3,
      configuration_status: this.isOtherPaymentEnabled ? 1 : 0,
      point_type: this.otherPaymentType === "each_payment" ? 1 : 2,
      point_value:
        this.otherPaymentType === "each_payment"
          ? this.othFixedPoints || 0
          : this.othRewardPoints || 0,
      payment_per_point:
        this.otherPaymentType === "payment_amount"
          ? this.othAmountLimit || 0
          : 0,
      validity_in_days: this.paymentOtherValidity || 0,
    });

    return configs;
  }

  savePaymentLoyaltyConfiguration() {
    const result =
      this.entityLoyaltyConfiguration.entity_loyalty_configuration.find(
        (item: any) => item.configuration_type === this.selectedValue,
      );

    const payload = {
      entity_hash: this.entityHash,
      created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      entity_loyalty_configuration_hash: result ? result.hash_id : 0,
      configurations: this.buildPaymentLoyaltyPayload(),
    };

    console.log("Payment Loyalty Payload", payload);

    this.ls.showLoader = true;
    this.apiservice.setEntityPaymentLoyaltyConfiguration(payload);
  }

  buildReferralLoyaltyPayload() {
    const configs: any[] = [];

    // On refer a friend → configuration_type = 1
    configs.push({
      configuration_type: 1,
      configuration_status: this.isReferFriendEnabled ? 1 : 0,
      point_type: 2, // always payment_amount based in your UI
      point_value: this.referFriendPoints || 0,
      payment_per_point: this.referFriendPoints ? 1 : 0,
      validity_in_days: this.referralValidity || 0,
      is_referee_point_applicable: this.isPointToReferee == true ? 1 : 0,
      referee_point_value: this.referFriendReferrerPoints || 0,
      referee_point_validity_in_days:
        this.referFriendReferredPointsValidity || 0,
    });

    // On booking by referee → configuration_type = 2
    configs.push({
      configuration_type: 2,
      configuration_status: this.isBookingByRefereeEnabled ? 1 : 0,
      point_type: 2,
      point_value: this.refereeBookingPoints || 0,
      payment_per_point: this.refereeBookingPoints ? 1 : 0,
      validity_in_days: this.referralBookingValidity || 0,
    });

    // On payment by referee → configuration_type = 3
    configs.push({
      configuration_type: 3,
      configuration_status: this.isPaymentByRefereeEnabled ? 1 : 0,
      point_type: this.referralPaymentType === "each_payment" ? 1 : 2,
      point_value:
        this.referralPaymentType === "each_payment"
          ? this.referralPaymentFixedPoints || 0
          : this.referralPaymentRewardPoints || 0,
      payment_per_point:
        this.referralPaymentType === "payment_amount"
          ? this.referralPaymentAmountLimit || 0
          : 0,
      validity_in_days: this.referralPaymentValidity || 0,
    });

    return configs;
  }

  saveReferralLoyaltyConfiguration() {
    const result =
      this.entityLoyaltyConfiguration.entity_loyalty_configuration.find(
        (item: any) => item.configuration_type === this.selectedValue,
      );
    const payload = {
      entity_hash: this.entityHash,
      created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      entity_loyalty_configuration_hash: result ? result.hash_id : 0,
      configurations: this.buildReferralLoyaltyPayload(),
    };

    console.log("Referral Loyalty Payload", payload);

    this.ls.showLoader = true;
    this.apiservice.setEntityReferralLoyaltyConfiguration(payload);
  }

  openPointConversion() {
    this.ls.showLoader = true;
    this.dialog.open(PointConversionComponent, {
      width: "500px",
      data: {
        entityHash: this.entityHash,
      },
    });
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }
}
